import { Grid } from "@mui/material";
import { Box, Container } from "@mui/system";
import { useQuery } from "@apollo/client";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { GET_BUSINESS_CATEGORIES } from "../../graphql/queries";
import { BusinessCategory } from "../../types";
import BusinessCategoryList from "../business/business/businessCategoryList";

const CategoriesList = () => {
  const {
    loading: loadingbusinessCategories,
    error: errorbusinessCategories,
    data: databusinessCategories,
  } = useQuery(GET_BUSINESS_CATEGORIES);

  const [categories, setbusinessCategories] = useState<BusinessCategory[]>([]);
  const navigate = useNavigate();
  const [selectedBusinessCategory, setSelectedBusinessCategory] =
    useState<BusinessCategory | null>(null);

  const currentCountryId = Number(localStorage.getItem("currentCountryId"));

  useEffect(() => {
    if (
      !errorbusinessCategories &&
      !loadingbusinessCategories &&
      databusinessCategories?.getBusinessCategories?.length > 0
    ) {
      const categoryNames = databusinessCategories.getBusinessCategories
        .filter(
          (category: any) =>
            category.businesses && category.businesses.length > 0
        ) // Filter categories with businesses
        .map((category: any) => {
          const hasBusinessInCountry = category.businesses.some(
            (business: any) =>
              // Check if business is in the current country and satisfies the display requirements
              business.countryId === currentCountryId &&
              (business.displayOnBookingPage === true ||
                business.businessBookingTypes?.some(
                  (bookingType: { displayOnBookingPage: boolean }) =>
                    bookingType.displayOnBookingPage === true
                ))
          );
          

          if (hasBusinessInCountry) {
            return {
              id: category.id,
              name: category.name,
            };
          }
          return null;
        })
        .filter((category: any) => category !== null);

      setbusinessCategories(categoryNames || []);
    } else {
      console.error("Invalid or empty array:", databusinessCategories);
    }
  }, [
    databusinessCategories,
    errorbusinessCategories,
    loadingbusinessCategories,
  ]);

  const handleBusinessCategorySelect = (businessCategory: BusinessCategory) => {
    navigate(
      `category/${businessCategory.id}_${businessCategory.name
        .toLowerCase()
        .replace(/ /g, "-")}`
    );
    setSelectedBusinessCategory(businessCategory);
  };

  return (
    <Container
      sx={{
        marginTop: { xs: "0.1rem", sm: "2rem" }, // Responsive margin top
        position: "relative", // Ensure positioning context is correct
        left: 0,
        right: 0,
      }}
    >
      <Box>
        <Grid container spacing={2} justifyContent="center">
          <BusinessCategoryList
            categories={categories}
            selectedBusinessCategory={selectedBusinessCategory}
            onSelect={handleBusinessCategorySelect}
          />
        </Grid>
      </Box>
    </Container>
  );
};

export default CategoriesList;
